@if (routes && activeRoute) {
  <div class="igo-input-container">
    @if (routes.length > 1) {
      <mat-form-field [matTooltip]="activeRoute.title">
        <mat-label>{{
          'igo.geo.directions.results.routeOptions' | translate
        }}</mat-label>
        <mat-select
          (selectionChange)="chooseRouteOption()"
          [(ngModel)]="activeRoute"
        >
          @for (route of routes; track route; let routeIndex = $index) {
            <mat-option [value]="route">
              Option {{ routeIndex + 1 }}: {{ route.title }} ({{
                formatDistance(route.distance)
              }}
              - {{ formatDuration(route.duration) }})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <h4 mat-header class="igo-route-title">
      {{ activeRoute.title }}
      {{ getTitleDurationAndDistance() }}
    </h4>
    <mat-list (mouseleave)="onLeaveList()">
      @for (step of activeRoute.steps; track step; let stepIndex = $index) {
        @if (
          (formatDistance(step.distance) && formatDuration(step.duration)) ||
          stepIndex === activeRoute.steps.length - 1
        ) {
          <mat-list-item
            matListItem
            class="igo-steps step"
            (mouseenter)="showStep(step)"
            (click)="showStep(step, true)"
          >
            <mat-icon
              matListItemIcon
              [matTooltip]="
                'igo.geo.directions.results.stepTitleTooltip' | translate
              "
              >{{ getFormattedStep(step, stepIndex).iconName }}
            </mat-icon>
            <span
              matListItemTitle
              class="step-title"
              [matTooltip]="getFormattedStep(step, stepIndex).instruction"
            >
              {{ getFormattedStep(step, stepIndex).instruction }}
            </span>
            @if (stepIndex !== activeRoute.steps.length - 1) {
              <span matListItemLine>
                {{ formatDistance(step.distance) }} -
                {{ formatDuration(step.duration) }}
              </span>
            }
          </mat-list-item>
        }
      }
    </mat-list>
  </div>
}
